var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.successMessage !== null)?_c('div',{staticClass:"bg-green-400 text-white font-bold p-4 rounded shadow-lg text-center"},[_vm._v(" "+_vm._s(_vm.successMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }